import DocumentCreationButton from 'Components/DocumentCreationButton';
import { Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import HistorySection from 'Components/HistorySection';
import { mmse } from 'neuro-schemas';
import { exists } from 'neuro-utils';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import DescriptionText from 'Routes/Cognition/utils/DescriptionText';
import { formatPartialDate } from 'Utility/date';

const { calculateScore } = mmse;

const MMSE = ({ documents, startEdit, view }: IOwnProps): React.JSX.Element => {
  const unableToPerformFound = documents.some(d => d.unableToPerform === true);
  return (
    <HistorySection
      headerText={<FormattedMessage id="cognition.mmse.mmseLong" />}
      newButton={
        <DocumentCreationButton
          name="mmse"
          text="cognition.mmse.newMmse"
          onClick={startEdit({}, 'mmse')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
      headerInfoText={<DescriptionText type={'mmse'} />}
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            <Item xs={2}>
              <FormattedMessage id="general.date" />
            </Item>
            <Item xs={3}>
              <FormattedMessage id="cognition.mmse.mmse" /> (0-30)
            </Item>
            <Item xs={2}>
              <FormattedMessage id="cognition.additionalInfo" />
            </Item>
            <Item xs={5}>{unableToPerformFound ? <FormattedMessage id="general.reason" /> : ''}</Item>
          </>
        }
        contentFormat={d => (
          <>
            <Item xs={2}>{formatPartialDate(d.date ?? undefined)}</Item>
            <Item xs={3}>
              {d.unableToPerform ? (
                <FormattedMessage id="cognition.unableToPerform" />
              ) : d.totalScoreOnly?.[0] ? (
                d.totalScore
              ) : (
                calculateScore(d)
              )}
            </Item>
            <Item xs={unableToPerformFound ? 2 : 4}>{d.additionalInfo}</Item>
            {unableToPerformFound ? (
              <Item xs={2}>
                {d.unableToPerform ? (exists(d.unableToPerformReason) ? d.unableToPerformReason : '-') : ''}
              </Item>
            ) : null}
            <Item xs={3}>
              <HistoryRowControls document={d} startEdit={startEdit} view={view} />
            </Item>
          </>
        )}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'mmse'>[];
  startEdit: StartEdit;
  view?: IView;
}

export default MMSE;
